export const everyHalfHour = () => {
  const meridiems = ['AM', 'PM'];
  const hours = ['12', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11'];
  const halfHours = [':00', ':30'];
  const times = [''];

  for (let i = 0; i < meridiems.length; i++) {
    for (let j = 0; j < hours.length; j++) {
      for (let k = 0; k < halfHours.length; k++) {
        times.push(`${hours[j]}${halfHours[k]}${meridiems[i]}`);
      }
    }
  }
  return times;
};

export const businessHours = () => {
  return [
    '',
    '08:00AM',
    '08:30AM',
    '09:00AM',
    '09:30AM',
    '10:00AM',
    '10:30AM',
    '11:00AM',
    '11:30AM',
    '12:00PM',
    '12:30PM',
    '01:00PM',
    '01:30PM',
    '02:00PM',
    '02:30PM',
    '03:00PM',
    '03:30PM',
    '04:00PM',
  ];
};



// WEBPACK FOOTER //
// ./src/common/utils/times.js